<ion-accordion-group #accordionGroup [id]="id">
  <ion-accordion toggleIcon="color-palette">
    <ion-item slot="header" style="--padding-start: 0; --inner-padding-end: 0;">
      <ion-label>{{label}}</ion-label>
      <ion-button
        *ngIf="rainbowIndex === 0 && !heartrate"
        class="labelButton"
        style="
          --background: linear-gradient(
            90deg,
            blue 0%,
            rgba(14, 251, 31, 1) 33%,
            rgba(243, 255, 0, 1) 66%,
            rgba(255, 0, 0, 1) 100%
          );
        "
      >
      </ion-button>
      <ion-button
        *ngIf="rainbowIndex === 0 && heartrate"
        class="labelButton"
        style="
          --background: linear-gradient(
            90deg,
            #989898 10%,
            #00a8d8 30%,
            #00a860 50%,
            #f8a820 70%,
            #f04040 90%
          );
        "
      >
      </ion-button>
      <ion-button
        *ngIf="rainbowIndex !== 0"
        class="labelButton"
        [style]="'--background:' + selectedColor"
      >
      </ion-button>
    </ion-item>
    <div class="ion-padding" slot="content">
      <ion-row>
        <ion-button
          *ngIf="rainbow && !heartrate"
          class="colorButton"
          [disabled]="rainbowIndex === 0"
          style="
            --background: linear-gradient(
              90deg,
              blue 0%,
              rgba(14, 251, 31, 1) 33%,
              rgba(243, 255, 0, 1) 66%,
              rgba(255, 0, 0, 1) 100%
            );
          "
          (click)="selectRainbowColor(0)"
        >
        </ion-button>
        <ion-button
          *ngIf="rainbow && heartrate"
          class="colorButton"
          [disabled]="rainbowIndex === 0"
          style="
            --background: linear-gradient(
              90deg,
              #989898 10%,
              #00a8d8 30%,
              #00a860 50%,
              #f8a820 70%,
              #f04040 90%
            );
          "
          (click)="selectRainbowColor(0)"
        >
        </ion-button>
        <ion-button
          *ngFor="let item of colors; let i = index"
          [disabled]="colorIndex === i"
          class="colorButton"
          [style]="'--background:' + item"
          (click)="selectColor(i)"
        >
        </ion-button>
        <ion-button
          *ngFor="let item of palette; let x = index"
          [disabled]="paletteIndex === x"
          class="colorButton"
          [style]="'--background:' + item"
          (click)="selectPaletteColor(x)"
        >
        </ion-button>
      </ion-row>
    </div>
  </ion-accordion>
</ion-accordion-group>
